import Vue from 'vue'

/**
 * @author Mariela Temozihui Tlahuel <mariela.temozihui@jbge.com.mx>
 *
 * Upload file to quotation
 *
 * @param  {object}
 */

const uploadFileQuotation = (payload, quotationId) =>
  Vue.$http.put(`purchase/quotation/response-file/${quotationId}/`, payload)
    .then()
    .catch(err => {
      throw err
    })

export default uploadFileQuotation


// WEBPACK FOOTER //
// ./src/services/purchase/quotation/uploadFileQuotation.js